import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('b-alert', {
    staticClass: "sa_note",
    attrs: {
      "show": "",
      "variant": "light"
    }
  }, [_c('div', [_c('strong', [_vm._v("串列設計")]), _vm._v(" —— 每一串的模組規格、方位角與傾角，作為串列同類比較與發電效率計算的依據。 ")]), _c('ul', {
    staticClass: "mb-0 mt-1"
  }, [_c('li', [_c('strong', [_vm._v("分組依據")]), _vm._v("：模組型號、瓦數、方位角、傾角、串接片數五者皆相同才歸為同一組。 「同儕群組代號」留空時由系統自動分組，需指定分組時再填寫。 ")]), _c('li', [_vm._v(" 按「由MPPT串列對應產生」會為每一條已接線的串列建立一列，規格填寫一次即可整批套用， 個別不同的串列再以「一鍵填入」修改。需"), _c('strong', [_vm._v("先完成「MPPT串列對應」")]), _vm._v("。 ")]), _c('li', [_vm._v(" 陣列位置請以「MPPT串列對應」為準，"), _c('strong', [_vm._v("不要沿用舊版 Excel 的位置")]), _vm._v("， 舊版在未接線處會往前遞補，導致後續串列整排錯位。 ")]), _c('li', [_vm._v("串列容量 = 瓦數 × 片數 ÷ 1000，由系統自動計算。")])])]), _c('MasterDataTable', _vm._g({
    ref: "table",
    attrs: {
      "table": "string_design",
      "def": _vm.def,
      "site-code": _vm.siteCode
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return [_c('b-button', {
          staticClass: "md_btn",
          attrs: {
            "size": "sm",
            "disabled": !_vm.siteCode,
            "title": "以 MPPT串列對應中已接線的串列為清單，規格填寫一次即可整批寫入"
          },
          on: {
            "click": function click($event) {
              _vm.open = true;
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-project-diagram"
        }), _vm._v(" 由MPPT串列對應產生 ")])];
      },
      proxy: true
    }])
  }, _vm.$listeners)), _c('b-modal', {
    attrs: {
      "title": "由 MPPT串列對應產生串列設計",
      "size": "lg",
      "scrollable": "",
      "ok-title": "寫入",
      "cancel-title": "取消",
      "ok-disabled": _vm.saving || !_vm.rows.length
    },
    on: {
      "show": _vm.onShow,
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    },
    model: {
      value: _vm.open,
      callback: function callback($$v) {
        _vm.open = $$v;
      },
      expression: "open"
    }
  }, [_vm.loadError ? _c('b-alert', {
    staticClass: "py-2 sd_hint",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.loadError))]) : !_vm.loading && !_vm.rows.length ? _c('b-alert', {
    staticClass: "py-2 sd_hint",
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_vm._v(" " + _vm._s(_vm.siteCode) + " 在「MPPT串列對應」中沒有已接線的串列，請先完成該分頁。 ")]) : _c('div', {
    staticClass: "sd_hint mb-2"
  }, [_vm._v(" 已接線的串列共 "), _c('strong', [_vm._v(_vm._s(_vm.rows.length))]), _vm._v(" 串（未接線位置不建立）。 "), _vm.existing ? [_vm._v(" 已經有 " + _vm._s(_vm.existing) + " 列，寫入時"), _c('strong', [_vm._v("已存在的位置會略過、不覆蓋")]), _vm._v("。 ")] : _vm._e()], 2), _vm._l(_vm.specColumns, function (c) {
    return _c('b-form-group', {
      key: c.name,
      staticClass: "mb-2",
      attrs: {
        "label": c.label + (c.required ? ' *' : ''),
        "description": c.hint,
        "label-cols-md": "3",
        "label-size": "sm"
      }
    }, [_c('b-form-input', {
      attrs: {
        "size": "sm",
        "type": c.type === 'text' || c.type === 'date' ? c.type : 'number',
        "step": c.type === 'int' ? 1 : 'any',
        "maxlength": c.maxLength
      },
      model: {
        value: _vm.spec[c.name],
        callback: function callback($$v) {
          _vm.$set(_vm.spec, c.name, $$v);
        },
        expression: "spec[c.name]"
      }
    })], 1);
  }), _vm.capacity ? _c('div', {
    staticClass: "sd_hint"
  }, [_vm._v("每串容量 " + _vm._s(_vm.capacity) + " kWp，全場 " + _vm._s((_vm.capacity * _vm.rows.length).toFixed(2)) + " kWp。")]) : _vm._e(), _vm.error ? _c('b-alert', {
    staticClass: "py-2 mb-0 mt-2",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };